import React from 'react';
import { Create, SimpleForm, ReferenceInput, SelectInput, TextInput, required, maxLength, Toolbar, SaveButton, useNotify, useRedirect } from 'react-admin';
import { Button } from '@mui/material';
import useAdmin from '../hooks/useAdmin';

const CustomToolbar = () => {
    const redirect = useRedirect();
    const handleBack = () => {
        redirect('/directorysubcategories');
    };
    return (
        <Toolbar>
            <SaveButton />
            <Button color="primary" onClick={handleBack} style={{ marginLeft: '10px' }}>Back</Button>
        </Toolbar>
    );
};

export const DirectorySubcategoryCreate = (props: any) => {
    const redirect = useRedirect();
    const notify = useNotify();
    const onSuccess = () => {
        notify('resources.directorysubcategories.notification.created', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'Directory Subcategory' },
        });
        redirect('/directorysubcategories');
    };
    useAdmin();
    return (
        <Create {...props} mutationOptions={{ onSuccess: onSuccess }}>
            <SimpleForm toolbar={<CustomToolbar />}>
                <ReferenceInput
                    source="category_id"
                    reference="directorycategories"
                    label="Category"
                >
                    <SelectInput optionText="category_name" validate={[required()]}/>
                </ReferenceInput>
                <TextInput
                    source="subcategory_name"
                    label="Subcategory Name"
                    validate={[required(), maxLength(50)]}
                />
                <TextInput
                    source="subcategory_description"
                    label="Description"
                    validate={maxLength(200)}
                />
            </SimpleForm>
        </Create>
    );
};

export default DirectorySubcategoryCreate;


